<template>
  <div id="timekeeping-page">
    <v-toolbar class="top-content" flat>
      <v-toolbar-title class="title-box">
        <span class="title">Timekeeping</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-flex xs3 sm5 class="mr-3">
        <v-text-field
          @click:clear="searchReference"
          append-icon="search"
          class="inp-search"
          clearable
          placeholder="Search by PO"
          v-model="search"
          v-on:keydown="searchReference"
        ></v-text-field>
      </v-flex>
      <v-menu
        :close-on-content-click="false"
        bottom
        full-width
        left
        offset-y
        v-model="dateMenu"
        class="ma-0 mr-3"
      >
        <v-btn
          color="grey darken-3"
          class="date-range-checked ma-0"
          outline
          slot="activator"
          >{{ new Date(range[0]) | morph-date("DD/MM/YYYY") }}
          &mdash;
          {{ new Date(range[1]) | morph-date("DD/MM/YYYY") }}</v-btn
        >
        <v-card>
          <v-card-text>
            <v-date-range
              :labels="labels"
              :options="dateRangeOptions"
              @input="onDateRangeChange"
              @cancelPicker="cancelPicker"
              @filterDateRange="filterDateRange"
            ></v-date-range>
          </v-card-text>
        </v-card>
      </v-menu>
      <v-btn
        color="grey darken-3"
        class="date-range-checked ma-0"
        outline
        @click="downloadAll()"
      >
        Download
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="timekeepingData"
      :loading="loading"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="totalItems"
      class="elevation-1 list-po"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr style="color: rgba(0, 0, 0, 0.87) !important">
          <td class="text-xs-left">
            {{ props.item.purchase_order.po_number }}
          </td>
          <td class="text-xs-left">
            {{ props.item.purchase_order.customer_name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.create_by.first_name }}
            {{ props.item.create_by.last_name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.create_by.phone }}
          </td>
          <td class="text-xs-center">
            {{ props.item.time_check_in | morph-date("DD/MM/YYYY") }}
          </td>
          <td class="text-xs-center">
            {{ props.item.time_check_out | morph-date("DD/MM/YYYY") }}
          </td>
          <td class="text-xs-center">
            {{
              !props.item.time_check_out
                ? ""
                : !props.item.job.isCompleted
                ? "Chưa hoàn thành"
                : "Hoàn thành"
            }}
          </td>

          <td class="text-xs-center">
            <v-icon @click="download(props.item)" small>file_download</v-icon>
          </td>
        </tr></template
      >
    </v-data-table>
  </div>
</template>

<script>
import TimekeepingService from "../services/timekeeping.service.js";
import * as json2csv from "json2csv";
import {
  format,
  subDays,
  startOfDay,
  endOfDay,
  startOfToday,
  endOfToday,
  endOfTomorrow,
  startOfTomorrow,
  addDays,
  startOfMonth,
  getDaysInMonth,
  lastDayOfMonth,
  lastDayOfWeek,
} from "date-fns";
import VDateRange from "../components/DateRange.vue";
import { debounce, isEmpty } from "lodash";

export default {
  components: { VDateRange },
  data: () => ({
    timekeepingService: new TimekeepingService(),
    loading: false,
    headers: [
      {
        text: "PO Number",
        value: "po_number",
        sortable: false,
      },
      {
        text: "Customer Name",
        value: "customer_name",
        sortable: false,
      },
      {
        text: "Technician Name",
        value: "technician_name",
        sortable: false,
      },
      {
        text: "Phone Number",
        value: "phone",
        sortable: false,
      },
      {
        text: "Time Checkin",
        value: "time_check_in",
        align: "text-xs-center",
        sortable: false,
      },
      {
        text: "Time Checkout",
        value: "time_check_out",
        align: "text-xs-center",
        sortable: false,
      },
      {
        text: "Status",
        value: "isCompleted",
        align: "text-xs-center",
        sortable: false,
      },
      {
        text: "Action",
        sortable: false,
        align: "text-xs-center",
      },
    ],
    timekeepingData: [],
    pagination: {
      rowsPerPage: 10,
      page: 1,
    },
    totalItems: 0,
    rowsPerPageItems: [10, 20, 50],
    labels: {
      start: "From Date",
      end: "To Date",
    },
    search: null,
    range: [],
    dateMenu: false,
    dateRangeOptions: {
      startDate: format(new Date(), "YYYY-MM-DD"),
      endDate: format(subDays(new Date(), -14), "YYYY-MM-DD"),
      format: "MM/DD/YYYY",
      maxDate: format(subDays(new Date(), -730), "YYYY-MM-DD"),
      dayInNextMonth: getDaysInMonth(
        new Date().setMonth(new Date().getMonth() + 1)
      ),
      presets: [
        {
          label: "Today",
          range: [
            format(startOfToday(), "YYYY-MM-DD"),
            format(endOfToday(), "YYYY-MM-DD"),
          ],
        },
        {
          label: "Tomorrow",
          range: [
            format(startOfTomorrow(), "YYYY-MM-DD"),
            format(endOfTomorrow(), "YYYY-MM-DD"),
          ],
        },
        {
          label: "Next Week",
          range: [
            format(
              addDays(
                lastDayOfWeek(new Date(), {
                  weekStartsOn: 1,
                }),
                1
              ),
              "YYYY-MM-DD"
            ),
            format(
              addDays(
                lastDayOfWeek(new Date(), {
                  weekStartsOn: 1,
                }),
                7
              ),
              "YYYY-MM-DD"
            ),
          ],
        } /*
          {
              label: "Next 7 Days",
              range: [
                  format(startOfTomorrow(), "YYYY-MM-DD"),
                  format(addDays(new Date(), 7), "YYYY-MM-DD")
              ]
          },*/,
        {
          label: "Next Month",
          range: [
            format(
              startOfMonth(new Date().setMonth(new Date().getMonth() + 1)),
              "YYYY-MM-DD"
            ),
            format(
              lastDayOfMonth(new Date().setMonth(new Date().getMonth() + 1)),
              "YYYY-MM-DD"
            ),
          ],
        },
      ],
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    searchUser() {
      this.querySearch();
    },
  },
  created() {
    this.range = [
      format(subDays(new Date(), 7), "YYYY-MM-DD"),
      format(new Date(), "YYYY-MM-DD"),
    ];
    this.rangTemp = this.range;
  },
  methods: {
    searchReference: debounce(function searchReference() {
      this.getData();
    }, 500),
    querySearch: debounce(function querySearch() {
      this.getData();
    }, 500),
    download(item) {
      const csvContent =
        "data:text/csv; charset=utf-8," +
        encodeURIComponent(
          "\uFEFF" +
            json2csv.parse([
              {
                "PO Number": item.purchase_order.po_number,
                "Customer Name": item.purchase_order.customer_name,
                "Technician Name": `${item.create_by.first_name} ${item.create_by.last_name}`,
                "Phone Number": item.create_by.phone,
                "Time Checkin": item.time_check_in
                  ? format(new Date(item.time_check_in), "DD/MM/YYYY HH:mm:ss")
                  : "",
                "Time Checkout": item.time_check_out
                  ? format(new Date(item.time_check_out), "DD/MM/YYYY HH:mm:ss")
                  : "",
                Status:
                  !item.job || !item.job.isCompleted
                    ? "Chưa hoàn thành"
                    : "Hoàn thành",
              },
            ])
        );

      const link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute("download", `${item.purchase_order.po_number}.csv`);
      link.click();
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage,
        from: startOfDay(new Date(this.range[0])).toISOString(),
        to: endOfDay(new Date(this.range[1])).toISOString(),
      };

      if (!isEmpty(this.search)) params.search = this.search;

      this.timekeepingService.getList(params).then((res) => {
        this.loading = false;
        if (res && res.docs) {
          this.timekeepingData = res.docs || [];
          this.totalItems = res.total || 0;
        }
      });
    },
    downloadAll() {
      this.loading = true;
      let params = {
        page: this.pagination.page,
        limit: 99999,
        from: startOfDay(new Date(this.range[0])).toISOString(),
        to: endOfDay(new Date(this.range[1])).toISOString(),
      };

      if (!isEmpty(this.search)) params.search = this.search;

      this.timekeepingService.getList(params).then((res) => {
        this.loading = false;
        let arrData = [];

        arrData = (res.docs || []).map((doc) => {
          return {
            "PO Number": doc.purchase_order.po_number,
            "Customer Name": doc.purchase_order.customer_name,
            "Technician Name":
              doc.create_by.first_name + " " + doc.create_by.last_name,
            "Phone Number": doc.create_by.phone,
            "Time Checkin": format(new Date(doc.time_check_in), "DD/MM/YYYY HH:mm:ss"),
            "Time Checkout": doc.time_check_out ? format(new Date(doc.time_check_out), "DD/MM/YYYY HH:mm:ss") : "",
            "Status": !doc.time_check_out
              ? ""
              : doc.job.isCompleted
              ? "Chưa hoàn thành"
              : "Hoàn thành",
          };
        });

        const csvContent =
          "data:text/csv; charset=utf-8," +
          encodeURIComponent("\uFEFF" + json2csv.parse(arrData));

        const link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", 'Timekeeping.csv');
        link.click();
      });
    },
    cancelPicker() {
      this.dateMenu = false;
    },
    filterDateRange() {
      this.range = this.rangTemp;
      this.from = this.rangTemp[0];
      this.to = this.rangTemp[1];
      this.dateMenu = false;
      this.getData();

      this.dateRangeOptions.startDate = this.from;
      this.dateRangeOptions.endDate = this.to;
    },
    onDateRangeChange(range) {
      this.rangTemp = range;
    },
  },
};
</script>
<style>
.v-input .v-input__slot {
  margin: 0 !important;
}
</style>
